<template>
  <div>
    <div class="content" style="width:auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}维修厂商</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">维修厂商基础信息</span>
          </div>
          <div class="">
            <el-row>
              <el-col :span="6">
                <el-form-item label="维修厂商编号" prop="no">
                  <el-input disabled v-model="form.no" placeholder="系统自动生成维修厂商编号" style="width:90%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="维修厂商名称" prop="name">
                  <el-input v-model="form.name" placeholder="请填写维修厂商名称" style="width:90%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="维修厂商级别" prop="level">
                  <el-select v-model="form.level" placeholder="请选择级别" style="width: 90%;">
                    <el-option v-for="item in LevelOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="维修厂商类型" prop="category">
                  <el-select v-model="form.category" placeholder="请选择类型" style="width: 90%;">
                    <el-option v-for="item in SupplierCategoryOptions" :key="item.id" :label="item.name + '厂商'" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item label="联系人" prop="contactor">
                  <el-input v-model="form.contactor" placeholder="请填写联系人" style="width:90%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="联系方式" prop="phone">
                  <el-input v-model="form.phone" placeholder="请填写联系方式" style="width:90%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="产地信息" prop="countryId">
                  <Address style="width:90%" :oldCountryId="form.countryId" :oldProvinceId="form.provinceId" :oldCityId="form.cityId" @change="getAddressData"></Address>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="详细地址" prop="address">
                  <el-input v-model="form.address" placeholder="请填写详细地址" style="width:90%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item label="组织机构代码" prop="creditCode">
                  <el-input v-model="form.creditCode" placeholder="请填写组织机构代码" style="width:90%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="开户银行" prop="openBank">
                  <el-input v-model="form.openBank" placeholder="请填写开户账号" style="width:90%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="开户账号" prop="bankAccount">
                  <el-input v-model="form.bankAccount" placeholder="请填写开户账号" style="width:90%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="备注" prop="remark">
                  <el-input v-model="form.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width:95%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="edit-card" style="margin-top:10px;padding-bottom:10px">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">维修厂商证件信息</span>
          </div>

          <div style="margin:20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" :disabled="childMultiple" type="danger" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
          </div>

          <el-table ref="childTable" border :data="form.details" style="width: auto;margin: 0 10px;" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="selection" fixed width="50" align="center" />
            <el-table-column label="证件类型" align="center" width="180" prop="category">
              <template slot-scope="scope">
                <el-select v-model="scope.row.category" style="width: 100%" filterable placeholder="请选择证件类型">
                  <el-option v-for="item in ManufacturerCertificateOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="证件编码" align="center" width="150" prop="no">
              <template slot-scope="scope">
                <el-input placeholder="请填写证件编码" v-model="scope.row.no"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="证件名称" align="center" width="150" prop="certificateName">
              <template slot-scope="scope">
                <el-input placeholder="请填写证件名称" v-model="scope.row.certificateName"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="证件生效日期" align="center" width="160" prop="startDate">
              <template slot-scope="scope">
                <el-date-picker v-model="scope.row.startDate" style="width: 100%" type="date" @change="dateChange(scope.row)" value-format="yyyy-MM-dd" placeholder="选择日期">
                </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column label="证件失效日期" align="center" width="230" prop="endDate">
              <template slot-scope="scope">
                <div style="display:flex;align-items: center;justify-content: center;">
                  <el-date-picker v-model="scope.row.endDate" style="width: 80%" type="date" @change="dateChange(scope.row)" value-format="yyyy-MM-dd" placeholder="选择日期" :picker-options="{
                      disabledDate(v) {
                        return endDateDisabledDate(v, scope.row);
                      },
                    }">
                  </el-date-picker>
                  <el-button class="btn default" size="small" style="margin-left:5px;width:60px;" v-preventReClick @click="changeEndDate(scope.row)">永久</el-button>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column label="上传附件" align="center" width="200">
              <template slot-scope="scope">
                <my-upload
                  @filesChange="(fileList) => filesChange(fileList, scope.row)"
                  :isLimitMaxSiz="true"
                  :oldList="scope.row.fileInfos"
                ></my-upload>
              </template>
            </el-table-column> -->
            <el-table-column show-overflow-tooltip label="上传附件" width="300px" align="center">
              <template slot-scope="scope">
                <div style="display:flex;align-items:center;">
                  <el-upload style="width:50%" class="upload-demo" ref="upload" :multiple="true" :show-file-list="false" :action="uploadAction" :accept="uploadFileType" :headers="uploadHeaders" :on-success="
                      (response, file, fileList) =>
                        onUploadSuccess(
                          response,
                          file,
                          fileList,
                          scope.row,
                          scope
                        )
                    ">
                    <el-button type="text">点击此处上传附件</el-button>
                  </el-upload>
                  <el-popover style="width:50%" placement="bottom" width="360" trigger="click">
                    <ul class="fileListUl_always" :key="'ul' + timeStamp">
                      <li class="fileItem" v-for="(item, index) in scope.row.fileInfos" :key="index">
                        <span class="fileName">{{ item.name }}</span>
                        <div class="btn_group canedit">
                          <span v-preventReClick @click="privewImg(item)">
                            点击查看
                          </span>
                          <span v-preventReClick @click="downloadImg(item)">
                            下载
                          </span>
                          <span v-preventReClick @click="RemoveFile(item, scope.row)">
                            删除
                          </span>
                        </div>
                      </li>
                    </ul>
                    <span slot="reference" class="show-files">
                      查看附件
                      <i class="el-icon-caret-top"></i>
                    </span>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="证书状态" align="center" width="100" prop="stateName">
              <template slot-scope="scope">
                <span :class="{
                    enable: scope.row.stateName != '过期',
                    forbidden: scope.row.stateName == '过期',
                  }">{{ scope.row.stateName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.remark"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-form-item label="启用状态">
          <el-switch v-model="form.state" active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0">
          </el-switch>
          <span v-if="form.state">已启用</span>
          <span v-else>已禁用</span>
        </el-form-item>
      </el-form>
      <!-- <div slot="footer" class="dialog-footer footer-bottom" style="margin-left: 35%; ">
      <el-button class="btn" size="small" v-preventReClick
            @click="cancel">取 消</el-button>
      <el-button class="btn primary" type="primary" size="small" v-preventReClick
            @click="submit">确 定</el-button>
    </div> -->

      <!-- <el-image-viewer :openViewer="openViewer" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" /> -->
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
    </div>
    <el-image-viewer :openViewer="dialogVisible" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" />
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import { GetRepairManufacturerById, SaveRepairManufacturer } from "@/api";
import {
  SupplierCategoryOptions,
  LevelOptions,
  ManufacturerCertificateOptions,
} from "@/enum";
import Address from "@/components/address";
import MyUpload from "@/components/my-upload";
import ElImageViewer from "@/components/elImageViewer";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin],
  components: {
    Address,
    MyUpload,
    ElImageViewer,
  },
  data () {
    return {
      title: "",
      form: {},
      SupplierCategoryOptions: SupplierCategoryOptions,
      LevelOptions: LevelOptions,
      ManufacturerCertificateOptions: ManufacturerCertificateOptions,
      rules: {
        name: [
          { required: true, message: "维修厂商名称不能为空", trigger: "blur" },
        ],
        category: [
          { required: true, message: "维修厂商类型不能为空", trigger: "blur" },
        ],
        creditCode: [
          { required: true, message: "社会信用代码不能为空", trigger: "blur" },
        ],
        contactor: [
          { required: true, message: "联系人不能为空", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "联系电话不能为空", trigger: "blur" },
          // {
          //   pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
          //   message: "请输入正确的手机号码",
          //   trigger: "blur",
          // },
        ],
      },
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      // fileId: 0,
      // fileName: '',
      // openViewer: false,
      countryId: "",
      provinceId: "",
      cityId: "",
      dialogVisible: false,
      dialogImageUrl: "",
      fileName: "",
      fileId: 0,
      timeStamp: "",
    };
  },
  props: {
    // title: {
    //   type: String,
    //   default () {
    //     return ''
    //   }
    // }
  },
  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }
  },
  methods: {
    // 新建
    handleAdd () {
      this.title = "新建";
      this.resetForm();
    },
    // 编辑
    handleUpdate (id) {
      GetRepairManufacturerById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.countryId = this.form.countryId;
        this.provinceId = this.form.provinceId;
        this.cityId = this.form.cityId;
        this.title = "编辑";
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.form.countryId = this.countryId || 0;
        this.form.provinceId = this.provinceId || 0;
        this.form.cityId = this.cityId || 0;
        SaveRepairManufacturer(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        })   .finally(() => {
            this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        name: "",
        state: 1,
        countryId: 0,
        provinceId: 0,
        cityId: 0,
        details: [],
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   });
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },
    handleAddChildForm () {
      if (!this.form.details) this.form.details = [];
      this.form.details.push({
        $index: this.form.details.length + 1,
        id: 0,
        categoryName: "",
        fileInfos: [],
        stateName: "",
        no: "",
        category: 1,
        certificateName: "",
        startDate: "",
        endDate: "",
        files: "",
        remark: "",
      });
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    changeEndDate (row) {
      row.endDate = "2099-12-31";
    },
    dateChange (row) {
      if (row.startDate && row.endDate) {
        // if (
        //   new Date(row.startDate) < new Date() &&
        //   new Date(row.endDate) >= new Date()
        // ) {
        //   row.stateName = "正常";
        // } else {
        //   row.stateName = "过期";
        // }
        if (new Date(row.endDate) < new Date()) {
          row.stateName = "过期";
        } else {
          row.stateName = "正常";
        }
      }
    },
    getAddressData (countryId, provinceId, cityId) {
      this.countryId = countryId;
      this.provinceId = provinceId;
      this.cityId = cityId;
    },

    // 上传附件
    filesChange (fileList, row) {
      row.fileInfos = fileList;
    },
    onUploadSuccess (response, file, fileList, row, scope) {
      response.returnData.forEach((item) => {
        // this.$set(this.form.details[scope.$index], "fileInfos", [item]);
        // row.fileInfos = [item];
        if (row.fileInfos.indexOf(item) == -1) {
          row.fileInfos.push(item);
        }
      });
      this.timeStamp = new Date().valueOf();
    },
    privewImg (file) {
      // this.dialogImageUrl = file.path;
      // this.dialogVisible = true;
      this.dialogVisible = true;
      this.fileId = file.id;
      this.fileName = file.name;
    },
    closeImageViewer () {
      this.dialogVisible = false;
    },
    RemoveFile (file, row) {
      var index = row.fileInfos.indexOf(file);
      if (index > -1) {
        row.fileInfos.splice(index, 1);
      }
    },
    endDateDisabledDate (v, row) {
      if (row.startDate) {
        return v.getTime() < new Date(row.startDate).getTime();
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
